import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// Helper to decode JWT and check expiry
const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    return payload.exp < now;
  } catch (e) {
    return true; // Consider invalid/malformed token as expired
  }
};

const ProtectedRoute = () => {
  const location = useLocation();
  const userId = localStorage.getItem("userId"); // 'guest_xxx' or real userId
  const token = localStorage.getItem("token"); // valid token for real or guest user

  const isGuestAllowedRoute =
    (location.pathname.startsWith("/challenge/waiting") ||
      location.pathname.startsWith("/practice/quiz") ||
      location.pathname.startsWith("/practice/results")) &&
    new URLSearchParams(location.search).has("inviteCode");

  // ✅ Allow access to guest routes
  if (isGuestAllowedRoute) return <Outlet />;

  // ❌ If token exists but expired
  if (token && isTokenExpired(token)) {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ✅ Allow if userId and token are valid
  if (userId && token) return <Outlet />;

  // ❌ Redirect all else to login
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default ProtectedRoute;
